import { createApiClient } from '@kanos/api-client';
import { inBackground } from './activity.js';
import { watchedFetch } from './connection.js';
/** The session's CSRF token, as last reported by `GET /api/v1/me` (ADR-005). */
let csrfToken;
export function rememberCsrfToken(token) {
    csrfToken = token;
}
/**
 * The app's API client; it adds the CSRF token to every state-changing request, marks the
 * requests sent while nobody works as background (ADR-005) and reports how each one went, so
 * the app can say when Kanos is out of reach (`ConnectionNotice`).
 */
export const api = createApiClient({
    csrfToken: () => csrfToken,
    background: () => inBackground(),
    fetch: watchedFetch,
});
/** An API answer the caller does not handle itself; `code` is the stable error code. */
export class ApiError extends Error {
    operation;
    code;
    name = 'ApiError';
    constructor(operation, code) {
        super(`${operation} failed: ${code}`);
        this.operation = operation;
        this.code = code;
    }
}
export const failure = (operation, error, status) => new ApiError(operation, error?.code ?? `http.${String(status)}`);
//# sourceMappingURL=api.js.map